import { ReactNode, useState } from 'react'
import { styled } from '@mui/material/styles'
import { ButtonProps, CircularProgress } from '@mui/material'
import { StyledComponent } from '@emotion/styled'

const StyledLoading = styled(CircularProgress)(({ theme }) => ({
  color: theme.palette.white,
}))

// TODO check for additional prop (needs logic)
interface Props extends ButtonProps {
  text: string | ReactNode
  onClick: () => any
}

interface StyledButtonProps {
  loading: boolean
}

export function createWithLoadingButton(button: StyledComponent<ButtonProps>) {
  // TODO it should be clear for color of button on hover
  const StyledButton = styled(button, {
    shouldForwardProp: prop => prop !== 'loading',
  })<StyledButtonProps>(({ theme, loading }) => ({
    '&.Mui-disabled': {
      background: loading
        ? `linear-gradient(0deg, rgba(0, 0, 0, 0.15), rgba(0, 0, 0, 0.15))`
        : `${theme.palette.lightGray}`,
    },
  }))

  return function({ text, onClick, ...props }: Props) {
    const [loading, setLoading] = useState(false)
    const handleOnClick = async () => {
      if (loading) return
      setLoading(true)
      try {
        await onClick()
      } finally {
        setLoading(false)
      }
    }
    return (
      <StyledButton
        {...props}
        onClick={handleOnClick}
        disabled={props.disabled || loading}
        loading={loading}
      >
        {loading ? <StyledLoading size={20} /> : text}
      </StyledButton>
    )
  }
}
